import api from './api';
import types from './mutation-types';
import moment from 'moment';

//날짜 포맷 변경 함수
const dateFormat = ts => {
	if (!ts) return ts;
	return moment(ts).format('YYYY-MM-DD HH:mm:ss');
};

export default {
	//State 변경 Action
	setState_({ commit }, { key, value }) {
		commit(types.SET_STATE, { key, value });
	},

	getPlants_: ({ state, commit }) => {
		return api
			.getPlants()
			.then(res => {
				if (res.header.code === 0) {
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'plants', value });
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	getCommCds_: ({ state, commit, rootState }, { key, commCdType }) => {
		return api
			.getCommCds({ plantCd: rootState.commonStore.user.plantCd, commCdType })
			.then(res => {
				if (res.header.code === 0) {
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key, value });
				}

				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	getStnCd_: ({ state, commit }, payload) => {
		// console.log(payload);
		return api
			.getStnCd(payload)
			.then(res => {
				if (res.header.code === 0) {
					const value = res.body.StationCodeList.map(({ stnCd, stnName }) => ({ label: `${stnCd}	${stnName}`, value: stnCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'stnCds', value });
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	select_: ({ state, commit }, { currentPage, pageUnit, ...params }) => {
		return api
			.fetchStations({ currentPage, pageUnit, params })
			.then(res => {
				if (res.header.code === 0) {
					const {
						resultList,
						pagingInfo: { currentPage, pageUnit, totalSize }
					} = res.body;

					//날짜 포맷 변경
					const data = resultList.map(row => ({
						...row,
						dRegDt: dateFormat((row.regDate + '' + row.regTime) * 1)
					}));

					commit(types.SET_STATE, { key: 'searchParams', value: params });

					commit(types.SET_STATE, { key: 'stations', value: { currentPage, pageUnit, totalSize, data } });
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	register_: ({ state, commit, dispatch }, payload) => {
		return api
			.register(payload)
			.then(res => {
				if (res.header.code === 0) {
					dispatch('select_', {
						currentPage: state.stations.currentPage,
						pageUnit: state.stations.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	modify_: ({ state, commit, dispatch }, payload) => {
		return api
			.modify(payload)
			.then(res => {
				if (res.header.code === 0) {
					dispatch('select_', {
						currentPage: state.stations.currentPage,
						pageUnit: state.stations.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	delete_: ({ state, commit, dispatch }, { station }) => {
		return api
			.delete(station)
			.then(res => {
				if (res.header.code === 0) {
					dispatch('select_', {
						currentPage: state.stations.currentPage,
						pageUnit: state.stations.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	}
};
